/* eslint-disable react-hooks/rules-of-hooks */
import { createContainer } from 'unstated-next';
import { AlertCollection, useAlerts } from '../components/AlertMessages/AlertMessages';

export const MessagesContainer = createContainer((): AlertCollection => {
	return useAlerts();
});
